import React, { useEffect } from 'react';

import SearchResultsBanner from 'app/modules/user/search/searchResultsBanner/SearchResultsBanner';
import useStore, { IStore } from 'app/store';

const SearchResult: React.FC = () => {
    const setUserSearchValue = useStore((state: IStore) => state.setUserSearchValue);
    const searchValueClear = useStore((state: IStore) => state.searchValueClear);
    useEffect(() => {
        return () => {
            if (searchValueClear) {
                setUserSearchValue('');
            }
        };
    }, [setUserSearchValue, searchValueClear]);

    return (
        <>
            <SearchResultsBanner />
        </>
    );
};

export default SearchResult;
